import { Injectable } from '@angular/core';
import { FluxStandardAction } from 'flux-standard-action';
export type Action = FluxStandardAction<any, any>;

@Injectable()
export class FileActions {
  /**
  * @arg Declaration of the action to store the uploaded capabilities or packages
  **/
  static readonly SET_UPLOADED_FILEDATA = 'SET_UPLOADED_FILEDATA';
  /**
   * @arg Declaration of the action to store if asi submitted or not
   **/
  static readonly SUBMIT_FILE = 'SUBMIT_FILE';
  /**
  * @arg Declaration of the action to store the file name
  **/
  static readonly SET_FILENAME = 'SET_FILENAME';
  /**
    * @arg Declaration of the action to store the file type
  **/
  static readonly SET_FILETYPE = 'SET_FILETYPE';
  /**
    * @arg SET_GENERATION to set generation
  **/
  static readonly SET_GENERATION = 'SET_GENERATION';
  /**
    * @arg SET_SUPPORTED_GENERATION to set generation
  **/
  static readonly SET_SUPPORTED_GENERATION = 'SET_SUPPORTED_GENERATION';
  /**
    * @arg SET_PACKAGE_GENERATION to set generation
  **/
  static readonly SET_PACKAGE_GENERATION = 'SET_PACKAGE_GENERATION';
  /**
  * @arg SET_PRODUCT_GENERATION to set generation
**/
  static readonly SET_PRODUCT_GENERATION = 'SET_PRODUCT_GENERATION';
  /**
    * @arg SET_ASI_GENERATION to set generation
  **/
  static readonly SET_ASI_GENERATION = 'SET_ASI_GENERATION';
  /**
    * @arg SET_ASI_PRODUCT_GENERATION to set asi product mapping component generation
  **/
  static readonly SET_ASI_PRODUCT_GENERATION = 'SET_ASI_PRODUCT_GENERATION';
  /**
    * @arg SET_REVIEW_APPROVED to set review approved
  **/
  static readonly SET_REVIEW_APPROVED = 'SET_REVIEW_APPROVED';

  /**
  * @method setUploadedFiledata sets the file data which is uploaded
  * @param parsedData parsed object from the file
  **/
  static setUploadedFiledata(parsedData: object) {
    return {
      type: FileActions.SET_UPLOADED_FILEDATA,
      payload: { uploadedFiledata: parsedData }
    };
  }
  /**
  * @method submitFile sets if the filie is submitted or not
  * @param value boolean
  **/
  static submitFile(value: boolean) {
    return {
      type: FileActions.SUBMIT_FILE,
      payload: { isFileSubmitted: value }
    };
  }
  /**
  * @method setFilename sets file name
  * @param file name of file
  **/
  static setFilename(file: string) {
    return {
      type: FileActions.SET_FILENAME,
      payload: { fileName: file }
    };
  }
  /**
  * @method setFiletype sets file type
  * @param type type of file
  **/
  static setFiletype(type: string) {
    return {
      type: FileActions.SET_FILETYPE,
      payload: { fileType: type }
    };
  }
  /**
  * @method setGeneration sets file type
  * @param generation string
  **/
  static setGeneration(generation: string) {
    return {
      type: FileActions.SET_GENERATION,
      payload: { generation }
    };
  }
  /**
  * @method setSupportedGeneration sets file type
  * @param generations string
  **/
  static setSupportedGeneration(supportedGenerations: Array<string>) {
    return {
      type: FileActions.SET_SUPPORTED_GENERATION,
      payload: { supportedGenerations }
    };
  }
  /**
  * @method setPackageGeneration sets file type
  * @param packageGeneration string
  **/
  static setPackageGeneration(packageGeneration: string) {
    return {
      type: FileActions.SET_PACKAGE_GENERATION,
      payload: { packageGeneration }
    };
  }
  /**
* @method setProductGeneration sets file type
* @param productGeneration string
**/
  static setProductGeneration(productGeneration: string) {
    return {
      type: FileActions.SET_PRODUCT_GENERATION,
      payload: { productGeneration }
    };
  }
  /**
* @method setAsiGeneration sets file type
* @param asiGeneration string
**/
  static setAsiGeneration(asiGeneration: string) {
    return {
      type: FileActions.SET_ASI_GENERATION,
      payload: { asiGeneration }
    };
  }
  /**
  * @method setAsiProductMapGeneration sets gen for asi product map
  * @param genration string
  **/
  static setAsiProductMapGeneration(generation: string) {
    return {
      type: FileActions.SET_ASI_PRODUCT_GENERATION,
      payload: { asiproductGeneration: generation }
    };
  }

  /**
  * @method setReviewApproved sets review approved
  * @param type type of file
  **/
  static setReviewApproved(type: string) {
    return {
      type: FileActions.SET_REVIEW_APPROVED,
      payload: { reviewApproved: type === 'approved' }
    };
  }
}
